import { Input } from 'antd';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import './style.css';

const LabeledInput = ({
  labelId,
  labelDefaultMessage,
  value,
  onChange,
  disabled,
}) => {
  return (
    <div className="labeled-input-container">
      <div className="labeled-input-label">
        {labelId && (
          <label>
            <FormattedMessage
              id={labelId}
              defaultMessage={labelDefaultMessage || labelId}
            />
          </label>
        )}
      </div>
      <Input
        value={value}
        onChange={onChange}
        disabled={disabled}
        className="labeled-input"
      />
    </div>
  );
};

export default LabeledInput;
